"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MEMBER_TOAST_CLOSE_BUTTON_TEST_ID = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _framerMotion = require("framer-motion");
var _Close = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close16"));
var _HBText = _interopRequireDefault(require("../../HBText/HBText"));
var _HBMediaElement = _interopRequireDefault(require("../../HBMediaElement/HBMediaElement"));
var _colors = _interopRequireDefault(require("../../../styles/colors"));
var _breakpoints = require("../../../styles/breakpoints");
var _mixins = require("../../../styles/mixins");
var _ToastActions = _interopRequireDefault(require("../ToastActions"));
var _ToastActionLink = _interopRequireDefault(require("../ToastActionLink"));
var _variables = require("../../../styles/variables");
var _HBButton = require("../../HBButton/HBButton.styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LOGO_SIZE = 54;
var ANIMATION_DURATION_IN_SEC = 0.5;
var REMOVE_TIMEOUT_IN_MS = 400;
var MEMBER_TOAST_CLOSE_BUTTON_TEST_ID = exports.MEMBER_TOAST_CLOSE_BUTTON_TEST_ID = 'hb-member-toast-close--button';
var MemberToast = function MemberToast(_ref) {
  var actionLink = _ref.actionLink,
    actions = _ref.actions,
    autoDismissMs = _ref.autoDismissMs,
    buttonTheme = _ref.buttonTheme,
    iconUrl = _ref.iconUrl,
    id = _ref.id,
    isDismissible = _ref.isDismissible,
    isFirstInQueue = _ref.isFirstInQueue,
    onDismiss = _ref.onDismiss,
    removeItem = _ref.removeItem,
    text = _ref.text,
    title = _ref.title;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isDismissed = _useState2[0],
    setIsDismissed = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isHovered = _useState4[0],
    setIsHovered = _useState4[1];
  var isShown = isFirstInQueue && !isDismissed;
  (0, _react.useEffect)(function () {
    if (autoDismissMs && isShown && !isHovered) {
      var timeoutId = setTimeout(function () {
        setIsDismissed(true);
      }, autoDismissMs);
      return function () {
        return clearTimeout(timeoutId);
      };
    }
  }, [autoDismissMs, isShown, isHovered]);
  (0, _react.useEffect)(function () {
    if (!isShown && isDismissed) {
      setTimeout(function () {
        return removeItem(id);
      }, REMOVE_TIMEOUT_IN_MS);
    }
  }, [id, isDismissed, isShown, removeItem]);
  var handleDismiss = function handleDismiss() {
    setIsDismissed(true);
    onDismiss === null || onDismiss === void 0 || onDismiss();
  };
  var onActionClick = function onActionClick(action) {
    action === null || action === void 0 || action.onClick();
    handleDismiss();
  };

  // use secondary button if 2 cta’s are needed
  // use only secondary cta as a stand alone button if the action is optional and the toast is dismissable
  var themedActions = (0, _react.useMemo)(function () {
    return actions === null || actions === void 0 ? void 0 : actions.map(function (action, idx) {
      var isSecondaryButton = idx === 0 && actions.length > 1 || actions.length === 1 && isDismissible;
      var secondaryTheme = _objectSpread(_objectSpread({}, buttonTheme), {}, {
        background: 'transparent',
        color: _colors["default"].neutral900,
        hoverBackgroundColor: _colors["default"].neutral200
      });
      return _objectSpread(_objectSpread({}, action), {}, {
        size: 'xs',
        customTheme: isSecondaryButton ? secondaryTheme : buttonTheme
      });
    });
  }, [actions, buttonTheme, isDismissible]);
  return /*#__PURE__*/_react["default"].createElement(MemberToastContainer, {
    key: id,
    transition: {
      duration: ANIMATION_DURATION_IN_SEC,
      ease: 'easeInOut'
    },
    initial: {
      opacity: 0,
      y: 200
    },
    animate: isShown ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 200
    },
    exit: {
      opacity: 0,
      y: 200
    },
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    }
  }, isDismissible && /*#__PURE__*/_react["default"].createElement(CloseIcon, {
    "data-testid": MEMBER_TOAST_CLOSE_BUTTON_TEST_ID,
    color: _colors["default"].neutral800,
    onClick: handleDismiss
  }), /*#__PURE__*/_react["default"].createElement(LogoAndTextContainer, null, iconUrl && /*#__PURE__*/_react["default"].createElement(CompanyLogo, null, /*#__PURE__*/_react["default"].createElement(_HBMediaElement["default"], {
    width: LOGO_SIZE,
    height: LOGO_SIZE,
    path: iconUrl,
    crop: "fit"
  })), /*#__PURE__*/_react["default"].createElement(TextContainer, null, title && /*#__PURE__*/_react["default"].createElement(Title, null, title), /*#__PURE__*/_react["default"].createElement(Text, null, text))), actions && /*#__PURE__*/_react["default"].createElement(ActionContainer, null, /*#__PURE__*/_react["default"].createElement(_ToastActions["default"], {
    actions: themedActions,
    onActionClick: onActionClick
  })), actionLink && /*#__PURE__*/_react["default"].createElement(_ToastActionLink["default"], {
    actionLink: actionLink,
    onActionClick: onActionClick
  }));
};
var _default = exports["default"] = MemberToast; // -------------------------------- Styles -------------------------------- //
var MemberToastContainer = (0, _styledComponents["default"])(_framerMotion.motion.div).withConfig({
  displayName: "MemberToast__MemberToastContainer",
  componentId: "sc-10mjj3c-0"
})(["position:fixed;z-index:", ";left:8px;bottom:30px;right:8px;margin-left:auto;", "{left:unset;bottom:80px;right:30px;}box-sizing:border-box;padding:20px;background-color:", ";border-radius:8px;box-shadow:0px 3px 10px rgba(40,63,136,0.05),0px 15px 40px rgba(40,63,136,0.15);", "{padding-left:12px;padding-right:12px;}max-width:420px;", ";", "{min-width:420px;max-width:520px;}"], _variables.Z_INDEX.TOAST, _breakpoints.mediumUp, _colors["default"].white, _HBButton.Button, _mixins.flexColumn, _breakpoints.mediumUp);
var CloseIcon = (0, _styledComponents["default"])(_Close["default"]).withConfig({
  displayName: "MemberToast__CloseIcon",
  componentId: "sc-10mjj3c-1"
})(["position:absolute;top:14px;right:14px;"]);
var CompanyLogo = _styledComponents["default"].div.withConfig({
  displayName: "MemberToast__CompanyLogo",
  componentId: "sc-10mjj3c-2"
})(["min-width:", "px;height:", "px;", ";border-radius:50%;border:1px solid ", ";margin-right:12px;overflow:hidden;"], LOGO_SIZE, LOGO_SIZE, _mixins.flexCenterAll, _colors["default"].black_01);
var LogoAndTextContainer = _styledComponents["default"].div.withConfig({
  displayName: "MemberToast__LogoAndTextContainer",
  componentId: "sc-10mjj3c-3"
})(["display:flex;align-items:top;"]);
var TextContainer = _styledComponents["default"].div.withConfig({
  displayName: "MemberToast__TextContainer",
  componentId: "sc-10mjj3c-4"
})(["", " margin-top:4px;margin-right:20px;"], _mixins.flexColumn);
var Title = (0, _styledComponents["default"])(_HBText["default"]).attrs({
  type: 'title14',
  color: 'textPrimary'
}).withConfig({
  displayName: "MemberToast__Title",
  componentId: "sc-10mjj3c-5"
})(["display:block;margin-bottom:4px;"]);
var Text = (0, _styledComponents["default"])(_HBText["default"]).attrs({
  type: 'body14',
  color: 'textPrimary'
}).withConfig({
  displayName: "MemberToast__Text",
  componentId: "sc-10mjj3c-6"
})(["display:block;white-space:pre-line;"]);
var ActionContainer = _styledComponents["default"].div.withConfig({
  displayName: "MemberToast__ActionContainer",
  componentId: "sc-10mjj3c-7"
})(["margin-top:12px;display:flex;justify-content:flex-end;button{margin-bottom:0;}"]);
//# sourceMappingURL=MemberToast.js.map